import { NavLink, useLocation } from "react-router-dom";
import { MessageCircle, Sparkles, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { useNotificationsContext } from "@/contexts/NotificationsContext";

const navItems = [
  { to: "/services", icon: Sparkles, label: "Services" },
  { to: "/chat", icon: MessageCircle, label: "Messages" },
  { to: "/profile", icon: User, label: "Profil" },
];

export default function BottomNav() {
  const location = useLocation();
  const { unreadCount } = useNotificationsContext();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass border-t border-border safe-bottom">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          // Check if on chat-related routes
          const isChatRoute = location.pathname === "/chat" || 
            location.pathname.startsWith("/chat/");
          const isActive = item.to === "/chat" 
            ? isChatRoute
            : location.pathname === item.to;
          
          // Show badge only on Messages tab
          const showBadge = item.to === "/chat" && unreadCount > 0;
          
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={cn(
                "flex flex-col items-center justify-center gap-1 w-full h-full transition-all duration-200 touch-feedback relative",
                isActive 
                  ? "text-primary" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <div className="relative">
                <item.icon 
                  size={22} 
                  className={cn(
                    "transition-transform duration-200",
                    isActive && "scale-110"
                  )} 
                />
                {showBadge && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] flex items-center justify-center bg-destructive text-destructive-foreground text-[10px] font-bold rounded-full px-1 animate-pulse">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </div>
              <span className="text-[10px] font-medium">{item.label}</span>
              {isActive && (
                <div className="absolute bottom-0 w-12 h-0.5 bg-primary rounded-full" />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
